<template>
  <div>
    <div class="background-container">
      <div class="about-title">
        22대 국회<span class="about-title-dot"></span>
      </div>
      <div class="national-menu">
        <button
          class="national-menu-item"
          :class="isNationalAssemblyShow ? 'active' : ''"
          @click="() => toggleContent(true)"
          type="button"
          v-html="nationalTitle"
        ></button>
        <button
          class="national-menu-item"
          :class="isNationalAssemblyShow ? '' : 'active'"
          @click="() => toggleContent(false)"
          type="button"
          v-html="congressmanTitle"
        ></button>
      </div>
    </div>

    <div class="national-content">
      <div class="national-content-inner">
        <NThNationalAssemblyTable
          :statisticsBiilCountData="statisticsBiilCountData"
          :statisticsBiilCountBottomData="statisticsBiilCountBottomData"
          v-if="isNationalAssemblyShow"
        />
        <NThCongressmanAssemblyTable v-else />
      </div>
    </div>
  </div>
</template>

<script>
import NThNationalAssemblyTable from "@/components/nthNationalAssembly/NThNationalAssemblyTable.vue";
import NThCongressmanAssemblyTable from "@/components/nthNationalAssembly/NThCongressmanAssemblyTable.vue";
import axios from "axios";

const sortBase = ["의원", "위원장", "정부", "계"];
export default {
  name: "NthNationalAssemblyPage",
  components: { NThNationalAssemblyTable, NThCongressmanAssemblyTable },
  data() {
    return {
      isNationalAssemblyShow: true,
      nationalTitle: "22대 국회 법안처리 현황판",
      congressmanTitle: "22대 국회의원 입법 현황판",

      statisticsBiilCountData: {
        // 발의건
        proposalCountList: [],
        // 처리건
        processingCountList: [],
        // 미처리건
        unprocessedCountList: [],
        // 처리율
        processingPercentList: [],
      },
      statisticsBiilCountBottomData: {
        //원안가결(건/비율)
        OBIL_PSSG_CNT_LIST: [],
        //수정가결(건/비율)
        AMND_PSSG_CNT_LIST: [],
        //대안반영폐기(건/비율)
        ALTPL_REFT_CNT_LIST: [],
        //수정안반영폐기(건/비율)
        AMND_REFT_CNT_LIST: [],
        //법률 반영 소계
        REFT_SUBT_LIST: [],
        //부결 건수
        RJCTN_CNT_LIST: [],
        // 폐기 건수
        DSU_CNT_LIST: [],
        // 철회 건수 비율
        WTHD_CNT_LIST: [],
        // 기타 건수 비율
        ETC_CNT_LIST: [],
        // 미반영 소계 건수 비율
        UN_REFT_SUBT_LIST: [],
      },
    };
  },

  watch: {
    $route(to) {
      this.isNationalAssemblyShow = to.query.type !== "congressman";
    },
  },

  created() {
    this.isNationalAssemblyShow = this.$route.query.type !== "congressman";
    this.getStatisticsBiilList();
  },

  mounted() {
    window.addEventListener("resize", this.checkScreenWidth);

    if (window.innerWidth <= 1040) {
      this.nationalTitle = "22대 국회<br/>법안처리 현황판";
      this.congressmanTitle = "22대 국회의원<br/>입법 현황판";
    } else {
      this.nationalTitle = "22대 국회 법안처리 현황판";
      this.congressmanTitle = "22대 국회의원 입법 현황판";
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenWidth);
  },

  methods: {
    checkScreenWidth() {
      if (window.innerWidth <= 1040) {
        this.nationalTitle = "22대 국회<br/>법안처리 현황판";
        this.congressmanTitle = "22대 국회의원<br/>입법 현황판";
      } else {
        this.nationalTitle = "22대 국회 법안처리 현황판";
        this.congressmanTitle = "22대 국회의원 입법 현황판";
      }
    },
    toggleContent(isNationalAssemblyShowParam) {
      this.isNationalAssemblyShow = isNationalAssemblyShowParam;
    },
    async getStatisticsBiilList() {
      try {
        const res = await axios.get(
          process.env.VUE_APP_TRAGET_URL +
            "/assembly/statistics/proposer?ERACO=제22대"
        );
        if (typeof res.data.list !== "undefined") {
          //sortBase 순서대로 정렬
          res.data.list.sort((a, b) => {
            const indexX = sortBase.indexOf(a.PRPSR_DIV_NM);
            const indexY = sortBase.indexOf(b.PRPSR_DIV_NM);

            // a 배열에 존재하지 않는 위원회들은 최하위로 배치
            if (indexX === -1) return 1; // x가 없으면 뒤로 보내기
            if (indexY === -1) return -1; // y가 없으면 뒤로 보내기

            return indexX - indexY; // 두 위원회가 a 배열에서 나타나는 순서대로 정렬
          });

          res.data.list.forEach((item) => {
            this.statisticsBiilCountData.proposalCountList.push(item.RCP_CNT);
            this.statisticsBiilCountData.processingCountList.push(
              item.PROC_CNT
            );
            this.statisticsBiilCountData.unprocessedCountList.push(
              item.UN_PROC_CNT
            );
            this.statisticsBiilCountData.processingPercentList.push(
              item.PROC_RATE
            );

            // 원안가결 건수
            this.statisticsBiilCountBottomData.OBIL_PSSG_CNT_LIST.push(
              item.OBIL_PSSG_CNT
            );

            // 원안가결 건수 비율
            this.statisticsBiilCountBottomData.OBIL_PSSG_CNT_LIST.push(
              item.OBIL_PSSG_RATE
            );

            // 수정안가결 건수
            this.statisticsBiilCountBottomData.AMND_PSSG_CNT_LIST.push(
              item.AMND_PSSG_CNT
            );
            // 수정안가결 비율
            this.statisticsBiilCountBottomData.AMND_PSSG_CNT_LIST.push(
              item.AMND_PSSG_RATE
            );

            // 대안반영건수
            this.statisticsBiilCountBottomData.ALTPL_REFT_CNT_LIST.push(
              item.ALTPL_REFT_CNT
            );
            // 대안반영 비율
            this.statisticsBiilCountBottomData.ALTPL_REFT_CNT_LIST.push(
              item.ALTPL_REFT_RATE
            );

            // 수정안반영건수
            this.statisticsBiilCountBottomData.AMND_REFT_CNT_LIST.push(
              item.AMND_REFT_CNT
            );
            // 수정안반영 비율
            this.statisticsBiilCountBottomData.AMND_REFT_CNT_LIST.push(
              item.AMND_REFT_RATE
            );

            // 법률반영 소계건수
            this.statisticsBiilCountBottomData.REFT_SUBT_LIST.push(
              item.REFT_SUBT
            );
            // 법률반영 소계 비율 (@todo 더블체크 문의)
            this.statisticsBiilCountBottomData.REFT_SUBT_LIST.push(
              item.REFT_SUBT_RATE
            );

            // 부결 건수
            this.statisticsBiilCountBottomData.RJCTN_CNT_LIST.push(
              item.RJCTN_CNT
            );
            // 부결 건수 비율
            this.statisticsBiilCountBottomData.RJCTN_CNT_LIST.push(
              item.RJCTN_RATE
            );

            // 폐기 건수
            this.statisticsBiilCountBottomData.DSU_CNT_LIST.push(item.DSU_CNT);
            // 폐기 건수 비율
            this.statisticsBiilCountBottomData.DSU_CNT_LIST.push(item.DSU_RATE);

            // 철회 건수
            this.statisticsBiilCountBottomData.WTHD_CNT_LIST.push(
              item.WTHD_CNT
            );
            // 철회 건수 비율
            this.statisticsBiilCountBottomData.WTHD_CNT_LIST.push(
              item.WTHD_RATE
            );

            // 기타 건수
            this.statisticsBiilCountBottomData.ETC_CNT_LIST.push(item.ETC_CNT);
            // 기타 건수 비율
            this.statisticsBiilCountBottomData.ETC_CNT_LIST.push(item.ETC_RATE);

            // 법률미반영 소계 건수
            this.statisticsBiilCountBottomData.UN_REFT_SUBT_LIST.push(
              item.UN_REFT_SUBT
            );
            // 법률미반영 소계 건수 비율
            this.statisticsBiilCountBottomData.UN_REFT_SUBT_LIST.push(
              item.UN_REFT_SUBT_RATE
            );
          });
        }
      } catch (exception) {
        console.error(`[getCongressmanBillData] - exception ${exception}`);
        alert("데이터 요청에 실패했습니다. 하단 이메일로 문의해주세요.");
      }
    },
  },
};
</script>

<style scoped>
.background-container {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../assets/img/main_01.jpg");
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
  height: 600px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  @media only screen and (max-width: 1040px) {
    background-attachment: initial;
  }
}

.about-title {
  position: relative;
  font-family: GmarketSansMedium;
  font-size: 70px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #fff;

  @media only screen and (max-width: 1040px) {
    font-size: 7vw;
  }
}

.about-title-dot {
  display: inline-block;
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #005aab;
  border-radius: 50%;
  right: -20px;
  top: -20px;
}

.national-menu {
  position: absolute;
  bottom: 0;
  height: 80px;
  background-color: #000;
  width: 100%;
  display: flex;
  justify-content: center;

  @media only screen and (max-width: 1040px) {
    padding: 0 10px;
    height: auto;
  }
}

.national-menu-item {
  width: 511px;
  justify-content: center;
  font-family: GmarketSansMedium;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  justify-content: center;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;

  @media only screen and (max-width: 1040px) {
    padding: 30px 0 26px 0;
    height: auto;
    font-weight: bold;
  }

  @media only screen and (max-width: 516px) {
    font-size: 21px;
  }
}

.national-menu-item.active {
  background-color: #fff;
  color: #000;
  border-radius: 20px 20px 0 0;
  opacity: 1;
}

.national-content {
  margin: 98px 0 0 0;
  padding: 0 30px;
  display: flex;
  justify-content: center;
}

.national-content-inner {
  max-width: 1320px;
  width: 100%;

  @media only screen and (max-width: 1040px) {
    text-align: center;
  }
}
</style>
